"use strict";
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var BaseComponent_1 = require("./base/BaseComponent");
var ko = require("knockout");
var ajaxUtils_1 = require("../../app/utils/ajaxUtils");
var SubToSeriesButtonComponent = (function (_super) {
    __extends(SubToSeriesButtonComponent, _super);
    function SubToSeriesButtonComponent(params, element, templateNodes) {
        var _this = this;
        _super.call(this, params, element, templateNodes);
        this.subscriptionId = ko.observable();
        this.isActive = ko.pureComputed(function () {
            return !!_this.subscriptionId();
        });
        this.subscriptionId(params.subscriptionId);
        this.seriesId = params.seriesId;
    }
    SubToSeriesButtonComponent.prototype.toggle = function () {
        var _this = this;
        if (!app.ensureAuth("Чтобы подписаться на цикл, необходимо авторизоваться")) {
            return;
        }
        if (this.processing())
            return;
        this.processing(true);
        if (this.isActive()) {
            ajaxUtils_1.AjaxUtils.post("work/series/unsubscribe", { subscriptionId: this.subscriptionId() })
                .done(function (result) {
                if (!result.isSuccessful) {
                    alert(result.messages[0]);
                    return;
                }
                _this.subscriptionId(null);
                alert("Вы отписались от уведомлений");
            })
                .always(function () {
                _this.processing(false);
            });
        }
        else {
            ajaxUtils_1.AjaxUtils.post("work/series/subscribe", { id: this.seriesId })
                .done(function (result) {
                if (!result.isSuccessful) {
                    alert(result.messages[0]);
                    return;
                }
                _this.subscriptionId(result.data);
                alert("Вы подписались на уведомления об обновлении цикла");
            })
                .always(function () {
                _this.processing(false);
            });
        }
    };
    return SubToSeriesButtonComponent;
}(BaseComponent_1.default));
ko.components.register("mobile-sub-to-series-button", {});
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = SubToSeriesButtonComponent;
//# sourceMappingURL=mobileSubToSeriesButton.js.map